export default __webpack_public_path__ + "static/media/wla_login.8224c963.png";